/**
 * The switch this product uses for a setting: a knob that slides from one end to the other, and the
 * track changes colour with it. The setting is named beside it, so the switch itself says nothing -
 * on and off are read from where the knob sits, as a switch is read everywhere else.
 *
 * It is teacher-web's `ToggleButton` rebuilt here in CSS, so a teacher meets the same control in
 * both screens and nothing is imported across the two apps to get it.
 *
 * A real checkbox does the work underneath, so it is reached by the Tab key, read as a checkbox by a
 * screen reader, and toggled by Space. The pill is painted by the stylesheet from `:checked`.
 */
export function Toggle(props: {
  label: string;
  checked: boolean;
  onChange: (next: boolean) => void;
  /** Lighter type, for the indigo header rather than a white dialog. */
  onDark?: boolean;
  title?: string;
}) {
  return (
    <label className={`aq-toggle${props.onDark ? ' aq-toggle-dark' : ''}`} title={props.title}>
      <span className="aq-toggle-label">{props.label}</span>
      <input
        type="checkbox"
        checked={props.checked}
        onChange={(e) => props.onChange(e.target.checked)}
      />
      <span className="aq-toggle-track" aria-hidden="true">
        <span className="aq-toggle-knob" />
      </span>
    </label>
  );
}

export default Toggle;
